import { getUser } from "../../../../../../scripts/auth";
import { authFecth } from "../../../../../../scripts/requests";
import { connector } from "../../../../../../variables/services";

export const get_connections = async (setConnections, filter, category='', project_id) => {
    let connections = []
    const user = getUser()
    await get_scoped_connections(conns => connections.push(...conns), filter, category=category, "account")
    await get_scoped_connections(conns => connections.push(...conns), filter, category=category, "project", project_id)
    setConnections(connections)
}

export const get_scoped_connections = async (setConnections, filter, category='', scope, project_id) => {
        let args = {
            filter: filter,
            category: category,
            scope: scope,
        }
        if (scope === "project") {
            args.project_id = project_id
        }
        await authFecth(`${connector}/connections`, "GET", args)
            .then(res => {
                if (!res.ok) { 
                return res.json().then(data => {
                    throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
                }
                return res.json();
            })
            .then(data => {
                setConnections(data)
            })
            .catch(error => {
                console.error("Error fetching connection:", error);
            });
            
        }

